import { useRef, useEffect, useState } from 'react';
import Snackbar from '@mui/material/Snackbar';

const SnackbarManager = ({ refreshCallback }) => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarBackgroundColor, setSnackbarBackgroundColor] = useState('red');
  const [triggerFunctionCall, setTriggerFunctionCall] = useState(false);

  const SNACKBAR_REFRESH_PERIOD = 3000;
  const SNACKBAR_RELOAD_PERIOD = 60000;
  const SNACKBAR_RELOADED_PERIOD = 3000;

  const refreshTimeoutRef = useRef();
  const isRefreshedTimeoutRef = useRef();
  const hideTimeoutRef = useRef();

  // Start the refresh cycle when component mounts
  useEffect(() => {
    isRefreshedTimeoutRef.current = setTimeout(() => {
      handleAboutToReload();
    }, SNACKBAR_RELOAD_PERIOD);
    return () => {
      clearAllTimeouts();
    };
  }, []);

  const clearAllTimeouts = () => {
    if (refreshTimeoutRef.current) clearTimeout(refreshTimeoutRef.current);
    if (isRefreshedTimeoutRef.current) clearTimeout(isRefreshedTimeoutRef.current);
    if (hideTimeoutRef.current) clearTimeout(hideTimeoutRef.current);
  };

  const handleAboutToReload = () => {
    clearAllTimeouts();

    setSnackbarOpen(true);
    setSnackbarMessage('Status: Refreshing... please wait...');
    setSnackbarBackgroundColor('red');

    refreshTimeoutRef.current = setTimeout(() => {
      handleReload();
    }, SNACKBAR_REFRESH_PERIOD);
  };

  const handleReload = () => {
    clearAllTimeouts();

    setSnackbarBackgroundColor('#4caf50');
    setSnackbarMessage('Status: Refreshed');

    setTriggerFunctionCall(true);

    hideTimeoutRef.current = setTimeout(() => {
      setSnackbarOpen(false);
    }, SNACKBAR_RELOADED_PERIOD);

    isRefreshedTimeoutRef.current = setTimeout(() => {
      handleAboutToReload();
    }, SNACKBAR_RELOAD_PERIOD);
  };

  useEffect(() => {
    if (triggerFunctionCall && refreshCallback) {
      refreshCallback();
      setTriggerFunctionCall(false);
    }
  }, [triggerFunctionCall, refreshCallback]);

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      open={snackbarOpen}
      message={snackbarMessage}
      sx={{
        '& .MuiSnackbarContent-root': {
          backgroundColor: snackbarBackgroundColor,
          color: 'white',
        },
        mt: 9,
      }}
    />
  );
};

export default SnackbarManager;
